import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";
import { videos } from "@/mocks/videos";
import { getFeaturedVideos, getHotVideos, getLatestVideos } from "@/utils/video";
import VideoCard from "@/components/feature/VideoCard";
import SectionHeading from "@/components/feature/SectionHeading";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickEntry from "@/pages/home/components/CategoryQuickEntry";

export default function Home() {
  useSEO({
    title: "糖豆视频 - 优质短视频分享与观看平台",
    description:
      "糖豆视频汇聚丰富的短视频内容，涵盖娱乐、生活、趣味等多种类别，用户可在糖豆视频平台轻松浏览与分享精彩视频。",
    keywords: "糖豆视频,短视频,视频分享,娱乐视频,生活视频,趣味视频,高清视频,视频平台",
  });

  const featured = getFeaturedVideos();
  const latest = getLatestVideos(6);
  const hot = getHotVideos(6);

  return (
    <div className="w-full">
      <HeroCarousel videos={featured} />

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <SectionHeading title="热门分类" subtitle="按兴趣快速找到你想看的内容" icon="ri-apps-2-line" />
        <CategoryQuickEntry />
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <SectionHeading
          title="最新视频"
          subtitle="刚刚上传的新鲜内容，第一时间看到"
          icon="ri-flashlight-line"
          moreTo="/search"
          moreLabel="去搜索更多"
        />
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-x-6 md:gap-y-8">
          {latest.map((video) => (
            <VideoCard key={video.id} video={video} showDate showCategory />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          title="热门视频"
          subtitle="大家都在看的高播放内容，跟着热度不踩坑"
          icon="ri-fire-line"
          moreTo="/search"
          moreLabel="发现更多"
        />
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-x-6 md:gap-y-8">
          {hot.map((video) => (
            <VideoCard key={video.id} video={video} showCategory />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-secondary-100">
            <img
              src="https://readdy.ai/api/search-image?query=Group%20of%20young%20friends%20watching%20short%20videos%20together%20on%20smartphones%20in%20a%20cozy%20bright%20cafe%2C%20warm%20natural%20light%2C%20cheerful%20relaxed%20atmosphere%2C%20modern%20lifestyle%20photography%2C%20soft%20tones&width=800&height=600&seq=td-intro&orientation=landscape"
              alt="用户在糖豆视频浏览短视频"
              title="糖豆视频 短视频分享平台"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-label font-medium text-primary-700">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-magic-line"></i>
              </span>
              关于糖豆视频
            </span>
            <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950 leading-snug">
              用碎片时间，看遍世界的有趣
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              糖豆视频聚焦优质短视频内容的分享与观看，覆盖娱乐、生活、趣味、美食、旅行、科技、音乐、运动等多个类别。我们希望每一次打开，都能让你在几分钟里收获快乐、灵感或者一点点治愈。
            </p>
            <div className="mt-6 grid grid-cols-3 gap-4">
              <div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">{videos.length}+</div>
                <div className="mt-1 text-xs text-foreground-500">优质视频</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">8</div>
                <div className="mt-1 text-xs text-foreground-500">内容分类</div>
              </div>
              <div>
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600">每日</div>
                <div className="mt-1 text-xs text-foreground-500">持续更新</div>
              </div>
            </div>
            <div className="mt-7 flex items-center flex-wrap gap-3">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                了解我们
              </Link>
              <Link
                to="/search"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
              >
                开始搜索视频
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}